import { TogetherAuctionDIPStageSelectComponent } from '../components/dip.stage_select.component';
export class TogetherHeaderLink {
    public link_title: string;
    public link_url: string;
    public is_active: boolean;

    /**
     * Creates an instance of TogetherHeaderLink.
     * @param {string} link_title
     * @param {string} link_url
     * @memberof TogetherHeaderLink
     */
    constructor(link_title: string, link_url: string, is_active: boolean = false) {
        this.link_title = link_title;
        this.link_url = link_url;
        this.is_active = is_active;
    }

    setActive() {
        this.is_active = true;
    }

}

export class TogetherHeaderLinks {
    public links: Array<TogetherHeaderLink> = [];

    /**
     * Creates an instance of TogetherHeaderLinks.
     * @param {any} links
     * @memberof TogetherHeaderLinks
     */
    constructor(links: Array<TogetherHeaderLink>) {
        this.links = links;
    }

    /**
     * Adds a link to the headerlinks object.
     *
     * @param {any} link_title
     * @param {any} link_url
     * @memberof TogetherHeaderLinks
     */
    addLink(link_title, link_url) {
        this.links.concat(new TogetherHeaderLink(link_title, link_url));
    }
}

export class TogetherBreadCrumb {
    public breadcrumb_title: string;
    public breadcrumb_url: string;
    public breadcrumb_is_active: boolean;

    constructor(title: string, url: string, active: boolean = false) {
        this.breadcrumb_title = title;
        this.breadcrumb_url = url;
        this.breadcrumb_is_active = active;
    }
}

export class TogetherCurrentPage {
    public page_title: string;
    public page_sub_title: string;
    public page_breadcrumbs: Array<TogetherBreadCrumb> = [
        new TogetherBreadCrumb('Home', '/', false),
    ];

    /**
     * Creates an instance of TogetherCurrentPage.
     * @param {string} title
     * @param {string} sub_title
     * @param {Array<TogetherBreadCrumb>} breadcrumbs
     * @memberof TogetherCurrentPage
     */
    constructor(title: string = '', sub_title: string = '', breadcrumbs: Array<TogetherBreadCrumb> = []) {
        this.page_title = title;
        this.page_sub_title = sub_title;
        this.page_breadcrumbs = breadcrumbs;
    }

    /**
     * Adds a breadcrumb to a trail.
     *
     * @param {TogetherBreadCrumb} breadcrumb
     * @memberof TogetherCurrentPage
     */
    addBreadCrumb(breadcrumb: TogetherBreadCrumb) {
        this.page_breadcrumbs.push(breadcrumb);
    }

    /**
      * Sets a breadcrumb trail.
      * @param {Array<TogetherBreadCrumb>} trail
      * @memberof TogetherCurrentPage
     */
    setBreadCrumbTrail(trail: Array<TogetherBreadCrumb>) {
        this.page_breadcrumbs = trail;
    }
}

/**
 * A stage for the together DIP stages.
 */
export class TogetherDIPStage {
    title: string;
    sub_title: string;
    num: number;
    forward_to_stage: number;
    link_style: string;

    page_title: string;
    summary: string;

    reference: string;
    forward_reference: string;
    backward_reference: string;
    heading_image: string;

    currentStep: number;
    stageDescription: string;

    constructor(params: object = {}) {
        Object.assign(this, params);
    }
}

export class TogetherDIPStageContainer {

    current_stage: TogetherDIPStage = new TogetherDIPStage();
    forward_stage: TogetherDIPStage = new TogetherDIPStage();
    backward_stage: TogetherDIPStage = new TogetherDIPStage();

}


export enum TogetherDIPState {

    // The item is being saved.
    Active = 0,

    // Has just recently been created, no GUID.
    New = 1,

    // Has been retrieved from API, has been saved.
    RetrievedFromAPI_New = 2,

    // Retrieved from API,
    RetrievedFromAPI_Results = 3,

    // It's been saved (this will initiate the view to restart)
    SavedWithAPI = 4,

    // We tried to save, but something went wrong and we're retrying.
    ErrorSavingWithAPIRetry = 5,

    // We tried to save and all hope is lost of saving. Sorry!
    ErrorSavingWithAPITimeout = 6,


}
